// translationUtils.js or any suitable file
import i18n from '../constants/languages'; // Import your i18n configuration

// Function to get translated text
export const translate = (key: any) => {
  return i18n.t(key);
};